import { render, staticRenderFns } from "./SelectC.vue?vue&type=template&id=38ed78c7&scoped=true&"
import script from "./SelectC.vue?vue&type=script&lang=js&"
export * from "./SelectC.vue?vue&type=script&lang=js&"
import style0 from "./SelectC.vue?vue&type=style&index=0&id=38ed78c7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ed78c7",
  null
  
)

export default component.exports